import { BaseResource, ResourceAction, ResourceActionV2, UuidResourceParam } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

import { PayerProposalStatusDto, payerProposalStatusSerializer } from "./payer";
import { PriceListProposalStatusDto, priceListProposalStatusSerializer } from "./priceList";

export type MyNotificationDto = {
  uuid: string;
  emittedAt: Date;
  payload: NotificationPayload;
};

export type NotificationPayload = AwaitingPriceListProposalsStatus | AwaitingPayerProposalsStatus;

export type NotificationPayloadType = NotificationPayload["type"];

export type AwaitingPriceListProposalsStatus = {
  type: "awaitingPriceListProposals";
  status: PriceListProposalStatusDto;
};

export type AwaitingPayerProposalsStatus = {
  type: "awaitingPayerProposals";
  status: PayerProposalStatusDto;
};

export type UnacknowledgedInvoiceThreadsStatus = {
  type: "unacknowledgedInvoiceThreads";
  threads: {
    uuid: string;
    title: string;
  }[];
};

export const notificationPayloadSerializer = MSerializers.match<NotificationPayload, NotificationPayload["type"]>(
  (i) => i.type,
  (i) => i.type,
  {
    awaitingPayerProposals: MSerializers.object<AwaitingPayerProposalsStatus>({
      type: MSerializers.stringOneOf("awaitingPayerProposals"),
      status: payerProposalStatusSerializer,
    }),
    awaitingPriceListProposals: MSerializers.object<AwaitingPriceListProposalsStatus>({
      type: MSerializers.stringOneOf("awaitingPriceListProposals"),
      status: priceListProposalStatusSerializer,
    }),
  },
);

export const feedMyNotificationResource = BaseResource(["feed", "myNotifications"], {
  byUuid: UuidResourceParam("notificationUuid", {
    dismiss: ResourceActionV2({
      name: "dismiss",
      method: "delete",
      path: "",
      responseErrorSerializer: MSerializers.stringOneOf<"NotificationNotFound">(),
    }),
  }),
  list: ResourceActionV2({
    name: "list",
    method: "get",
    path: "",
    responseValueSerializer: MSerializers.array(
      MSerializers.object<MyNotificationDto>({
        uuid: MSerializers.uuid(),
        emittedAt: MSerializers.datetime,
        payload: notificationPayloadSerializer,
      }),
    ),
  }),
});

export const feedNotificationsResource = BaseResource(["feed", "notifications"], {
  refresh: ResourceAction({
    name: "refresh",
    method: "post",
  }),
});
